import { Link } from "react-router-dom";


const Locationlock = () => {
    return (
        <section>
            <h1>where are you</h1>
            <br />
            <p>Location access is restricted for this page.</p>
            
            <div className="flexGrow">
                
                <Link to="/">Home</Link>
            </div>
        </section>
    )
}

export default Locationlock
